import { render, staticRenderFns } from "./FieldEditForm.vue?vue&type=template&id=4bb28fd0"
import script from "./FieldEditForm.vue?vue&type=script&lang=js"
export * from "./FieldEditForm.vue?vue&type=script&lang=js"
import style0 from "./FieldEditForm.vue?vue&type=style&index=0&id=4bb28fd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports